import * as React from "react";
import { QuestionActionType } from "../../../models/enums/QuestionActionType";
import { FontAwesomeIcon } from "../../shared/FontAwesome";

export default function ActionTypeIcon({ type }) {
    switch (type) {
        case QuestionActionType.BranchTo:
            return <FontAwesomeIcon fixedWidth icon={["far", "code-branch"]} />;
        case QuestionActionType.ComputeVariable:
        case QuestionActionType.SetVariableValue:
            return <FontAwesomeIcon fixedWidth icon={["far", "function"]} />;
        case QuestionActionType.ExitSurvey:
            return <FontAwesomeIcon fixedWidth icon={["far", "sign-out"]} />;
        case QuestionActionType.MobileAudioRecording:
            return <FontAwesomeIcon fixedWidth icon={["far", "microphone"]} />;
        case QuestionActionType.Selection:
            return <FontAwesomeIcon fixedWidth icon={["far", "ballot-check"]} />;
        case QuestionActionType.SendEmail:
            return <FontAwesomeIcon fixedWidth icon={["far", "envelope"]} />;
        case QuestionActionType.SetLoopRow:
            return <FontAwesomeIcon fixedWidth icon={["far", "undo-alt"]} />;
        case QuestionActionType.SetPanelistData:
            return <FontAwesomeIcon fixedWidth icon={["far", "person-sign"]} />;
        default:
            return null;
    }
}
